/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Status_DefaultInputs */

const en_statement_taxonomy_status_default = /** @type {(inputs: Statement_Taxonomy_Status_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default`)
};

const nl_statement_taxonomy_status_default = /** @type {(inputs: Statement_Taxonomy_Status_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standaard`)
};

/**
* | output |
* | --- |
* | "Default" |
*
* @param {Statement_Taxonomy_Status_DefaultInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_status_default = /** @type {((inputs?: Statement_Taxonomy_Status_DefaultInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Status_DefaultInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_status_default(inputs)
	return en_statement_taxonomy_status_default(inputs)
});